import React from 'react'
import "./index.scss"
import Logo from "../HeaderNav/logo.png"
import {LOCALES_HELPER} from "../../locales/config";
import intl from "react-intl-universal";

export function FooterFixed() {
    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            <footer id="main-footer" className="fixed-footer">
                <div className="container">
                    <div className="row">

                        <div className="col-sm-12 text-center">
                            <div className="footer-widget">
                                <a href="#"><img src={Logo} alt="EDENA website template"
                                                 className="pb responsive cus-logo"/></a>
                                <address>
                                    <p>
                                        {intl.get('foot-addr')}

                                    </p>
                                </address>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="footer-rights">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <p>Copyright © 2020 <a href="http://www.gzrebornendo.com/" target="blank">Reborn
                                    Endo</a> / All rights reserved.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}
